import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IAuthData } from '@sv/interfaces';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { TicketcodeAuthService } from './ticketcode-auth.service';
import { AppRoutingModule } from 'src/app/app-routing.module';
import jwt_decode from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private token: string;
  private authStatusListener = new Subject<boolean>();
  private isAuthenticated = false;
  private tokenTimer: any;

  constructor(
    private http: HttpClient,
    private router: Router,
    private ticketAuthServer: TicketcodeAuthService,
    private routingModel: AppRoutingModule
  ) {}

  getToken() {
    return this.token;
  }

  decodedToken(token: string): any {
    try {
      const decoded = (jwt_decode(token) as any).data;
      return decoded;
    } catch (error) {
      return undefined;
    }
  }

  getAuthStatusListener() {
    return this.authStatusListener.asObservable();
  }

  getIsAuthenticted() {
    return this.isAuthenticated;
  }

  createUser(username: string, password: string) {
    const authData: IAuthData = { username, password };
    this.http.post('http://localhost:3000/api/user/signup', authData).subscribe((response) => {
      console.log(response);
    });
  }

  autoAuthUser() {
    const authInformation = this.getAuthData();
    const now = new Date();
    const expiresIn = authInformation.expirationDate.getTime() - now.getTime();
    if (expiresIn > 0) {
      this.token = authInformation.token;
      this.isAuthenticated = true;
      this.authStatusListener.next(true);
      this.setAuthTimer(expiresIn / 1000);
    }
  }

  login(username: string, password: string) {
    const authData: IAuthData = { username, password };
    this.http.post<{ token: string; expiresIn: number }>('http://localhost:3000/api/user/login', authData).subscribe((response) => {
      const token = response.token;

      if (token) {
        const expiresInDuration = response.expiresIn;
        const now = new Date();
        const expirationDate = new Date(now.getTime() + expiresInDuration * 1000);

        this.token = token;
        this.authStatusListener.next(true);
        this.isAuthenticated = true;
        this.saveAuthData(token, expirationDate);
        this.setAuthTimer(expiresInDuration);
      }
    });
  }

  logout() {
    this.token = null;
    this.isAuthenticated = false;
    this.authStatusListener.next(false);
    clearTimeout(this.tokenTimer);
    this.clearAuthData();
    this.ticketAuthServer.logout();
    const initalRoutes = this.routingModel.getInitalRoutes();
    this.router.resetConfig(initalRoutes);
    this.router.navigate(['/']);
    localStorage.clear();
  }

  private setAuthTimer(duration: number) {
    this.tokenTimer = setTimeout(() => {
      this.logout();
    }, duration * 1000);
  }

  private saveAuthData(token: string, expirationDate: Date) {
    localStorage.setItem('token', token);
    localStorage.setItem('expiration', expirationDate.toISOString());
  }

  private clearAuthData() {
    localStorage.removeItem('token');
    localStorage.removeItem('expiration');
  }

  private getAuthData() {
    const token = localStorage.getItem('token');
    const expirationDate = localStorage.getItem('expiration');
    if (!token || !expirationDate) {
      return;
    }
    return {
      token,
      expirationDate: new Date(expirationDate)
    };
  }
}
